/**
 * API 全局配置
 */

export const apiConfig = {
  /** 基础 URL，来自环境变量 */
  baseURL: import.meta.env.VITE_API_BASE_URL ?? '',

  /** 请求超时时间（毫秒），默认 120 秒 */
  timeout: 120000,

  /** 默认请求头 */
  headers: {
    'Content-Type': 'application/json',
    /** 管理端默认政务网；可由 VITE_LOCATION_SERVER 覆盖 */
    Locationserver: (import.meta.env.VITE_LOCATION_SERVER || 'zhengwu').trim() || 'zhengwu',
  } as Record<string, string>,
}
